import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Box, H2 } from '@codex/basics';
import { Icon } from '@codex/icons';

const StyledBox = styled(Box)`
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translate(-50%, -50%);
  z-index: 1002;
  display: flex;
  width: 80%;
  max-width: 350px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 5px;
  border: 0;
  box-shadow: 1px 2px 4px 0 rgba(34, 34, 34, 0.3);
`;

const StyledSpinner = styled(Icon)`
  margin-bottom: 11px;
  color: #161B7A;
`;

const StyledH2 = styled(H2)`
  font-size: 18px;
`;

const StyledParagraph = styled.p`
  background: #f5f7fd;
  border: 0;
  text-align: center;
  padding: 7px 26px;
  width: 88%;
  margin: 0;
`;

const EligibilityCheckLoader = (props) => ReactDOM.createPortal(
  <StyledBox>
    <button
      type={'button'}
      onClick={() => props.loader()}
    >
      Hide overlay
    </button>
    <StyledSpinner
      icon={'Spinner'}
      size={'large'}
      spin
    />
    <StyledH2>Performing eligibility check</StyledH2>
    <StyledParagraph>
      Confirming your details. Please don&apos;t close this page.
      <br />
      This may take up to 30-seconds.
    </StyledParagraph>
  </StyledBox>,
  document.querySelector('body')
);

EligibilityCheckLoader.displayName = 'EligibilityCheckLoader';

export default EligibilityCheckLoader;
